import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconPresentationProps } from "@insite/mobius/Icon";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { RefObject, useContext, useState } from "react";
import { css } from "styled-components";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import getColor from "@insite/mobius/utilities/getColor";
import provinces from "@WhiteCap/Utils/Province";
import { BrickModel, brickService } from "@WhiteCap/Services/BrickQuoteService";
import useQuoteCartProduct from "@WhiteCap/Hooks/useQuoteCartProduct";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import { AttributeKeyTypeWithLabel, getAttributesWithLabelValue } from "@WhiteCap/Utils/GetAttribute";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import { connect, ResolveThunks } from "react-redux";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import ReCAPTCHA from "react-google-recaptcha";

const enum fields {
    emailRecipients = "emailRecipients",
}

const emailsRegexp = new RegExp(
    "^[\\W]*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4}[\\W]*,{1}[\\W]*)*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4})[\\W]*$",
);

interface OwnProps extends WidgetProps {
    fields: {
        [fields.emailRecipients]: string;
    };
}

type Props = OwnProps & HasHistory & ResolveThunks<typeof mapDispatchToProps>;

const mapDispatchToProps = {
    validateReCaptcha: makeHandlerChainAwaitable<{ location: string; recaptchaRef: RefObject<ReCAPTCHA> }, boolean>(
        validateReCaptcha,
    ),
}

export interface QouteCartFormStyles {
    form?: InjectableCss;
    formHeading?: InjectableCss;
    shareMessageTextArea?: TextAreaProps;
    textAreaGrid?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    centeringWrapper?: InjectableCss;
    mainGridContainer?: GridContainerProps;
    userGridItem?: GridItemProps;
    userGridContainer?: GridContainerProps;
    emailGridItem?: GridItemProps;
    emailTextField?: TextFieldPresentationProps;
    userNameGridItem?: GridItemProps;
    companyNameGridItem?: GridItemProps;
    userNameTextField?: TextFieldPresentationProps;
    selectProvince?: SelectPresentationProps;
    passwordGridItem?: GridItemProps;
    passwordTextField?: TextFieldPresentationProps;
    passwordIcon?: IconPresentationProps;
    confirmPasswordGridItem?: GridItemProps;
    confirmPasswordTextField?: TextFieldPresentationProps;
    confirmPasswordIcon?: IconPresentationProps;
    subscriptionGridItem?: GridItemProps;
    submitErrorGridItem?: GridItemProps;
    submitErrorTitle?: TypographyProps;
    submitGridItem?: GridItemProps;
    reCaptchaGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    requirementsGridItem?: GridItemProps;
    requirementsTitle?: TypographyProps;
    passwordRequirementsGridItem?: GridItemProps;
    passwordRequirementsGridContainer?: GridContainerProps;
    passwordGridContainer?: GridContainerProps;
}

export const qouteCartFormStyles: QouteCartFormStyles = {
    textAreaGrid: {
        css: css`
            width: 100% !important;
            max-width: 100% !important;
        `,
    },
    selectProvince: {
        css: css`
            background: #fff !important;
            border: 1px solid #6f6f6f !important;
            border-radius: 1px !important;
            font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
            font-size: 14px !important;
            line-height: 1.42857143 !important;
            font-weight: 400 !important;
            border-width: 1px !important;
            height: 38px !important;
            &:focus {
                outline: none !important;
            }
        `,
    },
    shareMessageTextArea: {
        css: css`
            background: #fff !important;
            height: 100px !important;
            border: 1px solid #6f6f6f !important;
            border-radius: 1px !important;
            font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
            font-size: 14px !important;
            line-height: 1.42857143 !important;
            font-weight: 400 !important;
            width: 100% !important;
            border-width: 1px !important;
            &:focus {
                outline: none !important;
                padding: 10px 10px 8px 10px !important;
            }
        `,
    },
    form: {
        css: css`
            border-top: 3px solid #f2b124;
            background: #fff;
            box-shadow: 4px 4px 8px 2px rgba(0, 0, 0, 0.16);
            padding: 20px;
        `,
    },
    mainGridContainer: {
        css: css`
            margin-bottom: 25px;
        `,
    },
    companyNameGridItem: {
        css: css`
            width: 100% !important;
            max-width: 100% !important;
            flex-basis: 100% !important;
        `,
    },
    submitButton: {
        css: css`
            width: 100%;
            background: #323031;
            color: #fff;
            text-align: center;
            font-size: 14px;
            font-weight: 600;
            line-height: 22px;
            text-transform: uppercase;
            font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
            border: 0;
            padding: 14px 17px;
            border-radius: 10px;
            &:hover {
                color: #000;
                background: #ffc111;
            }
            &:disabled {
                &:hover {
                    background: #cccccc;
                    border-color: #cccccc;
                    color: #ffffff;
                }
            }
        `,
    },
    formHeading: {
        css: css`
            font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
            text-transform: uppercase;
            display: flex;
            align-items: center;
            &:after {
                content: "";
                width: 50%;
                height: 2px;
                background: #f2b124;
                flex-grow: 1;
                margin-left: 16px;
                display: block;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 15px;
                        `,
                        css`
                            font-size: 15px;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    centeringWrapper: {
        css: css`
            display: flex;
            height: 300px;
            justify-content: center;
            align-items: center;
        `,
    },
    userGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            max-width: 100%;
                            flex-basis: 100%;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    userGridContainer: {
        css: css`
            div[class^="GridItemStyle"] {
                flex: none;
                width: 50%;
                padding: 15px 5px 7px 17px;
                &:nth-child(even) {
                    padding: 15px 17px 7px 17px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    padding: 15px 5px 7px 17px;
                                `,
                                css`
                                    padding: 15px 5px 7px 17px;
                                `,
                                null,
                            ],
                            "max",
                        )}
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 100%;
                            `,
                            css`
                                width: 100%;
                            `,
                            null,
                        ],
                        "max",
                    )}
            }
            div[class^="FormFieldStyle"] {
                label[class^="TypographyStyle"] {
                    color: #333;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 22px;
                    text-transform: uppercase;
                    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
                    span {
                        color: #e02b27;
                        font-size: 13px;
                        margin: 0 0 0 3px;
                    }
                }
                div[class^="FormInputWrapper"] {
                    position: relative;
                    input {
                        background: #fff;
                        border: 1px solid #6f6f6f;
                        border-radius: 1px;
                        font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
                        font-size: 14px;
                        height: 38px;
                        line-height: 1.42857143;
                        padding: 0 9px;
                        width: 100%;
                        &:focus {
                            border: 1px solid #6f6f6f;
                        }
                    }
                    div[class^="DescriptionWrapper"] {
                        position: absolute;
                        margin: 0;
                        width: 100%;
                        span {
                            color: ${getColor("danger.main")};
                            font-size: 12px;
                            font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
                            font-weight: 400;
                        }
                    }
                    span[class^="IconWrapper"] {
                        background: #fff;
                        height: 35px !important;
                        svg {
                            color: #333;
                            background: #fff;
                        }
                    }
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            // max-width: 300px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    emailGridItem: {
        width: 12,
    },
    userNameGridItem: {
        width: 12,
    },
    passwordGridItem: {
        width: 12,
    },
    confirmPasswordGridItem: {
        width: 12,
    },
    subscriptionGridItem: {
        width: 12,
    },
    submitErrorGridItem: {
        width: 12,
    },
    submitErrorTitle: {
        color: "danger",
    },
    reCaptchaGridItem: { width: 12 },
    submitGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    requirementsGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding-left: 50px;
                        `,
                    ],
                    "min",
                )}/* stylelint-disable-line declaration-block-single-line-max-declarations */
        `,
    },
    passwordRequirementsGridContainer: {
        gap: 5,
    },
    passwordRequirementsGridItem: {
        width: 12,
    },
    requirementsTitle: {
        variant: "h4",
        as: "h2",
    },
};

const styles = qouteCartFormStyles;
const StyledForm = getStyledWrapper("form");

const QuoteCartForm = ({ fields, history, validateReCaptcha }: Props) => {
    const { emailRecipients } = fields;

    const requiredFieldMessage = translate("This is a required field");
    const emailRequiredFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_Required");
    const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");
    const { cart, removeQuoteCartFromLocalStorage } = useQuoteCartProduct();

    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [phone, setPhone] = useState("");
    const [city, setCity] = useState("");
    const [province, setProvince] = useState("");
    const [message, setMessage] = useState("");
    const [firstNameError, setFirstNameError] = useState(requiredFieldMessage);

    const [lastNameError, setLastNameError] = useState(requiredFieldMessage);
    const [companyNameError, setCompanyNameError] = useState(requiredFieldMessage);
    const [phoneError, setPhoneError] = useState(requiredFieldMessage);
    const [cityError, setCityError] = useState(requiredFieldMessage);
    const [provinceError, setProvinceError] = useState(requiredFieldMessage);
    const [messageError, setMessageError] = useState(requiredFieldMessage);

    const [errorMessage, setErrorMessage] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [emailError, setEmailError] = useState(emailRequiredFieldMessage);
    const toasterContext = useContext(ToasterContext);
    const recaptchaRef: RefObject<ReCAPTCHA> = React.createRef();

    const validateFirstName = (name: string) => {
        const errorMessage = !name ? requiredFieldMessage : "";
        setFirstNameError(errorMessage);
        return !errorMessage;
    };

    const validateLastName = (name: string) => {
        const errorMessage = !name ? requiredFieldMessage : "";
        setLastNameError(errorMessage);
        return !errorMessage;
    };

    const validateFirmName = (companyName: string) => {
        const errorMessage = !companyName ? requiredFieldMessage : "";
        setCompanyNameError(errorMessage);
        return !errorMessage;
    };

    const validatePhone = (phone: string) => {
        const phonePattern = /^\(\d{3}\) \d{3}-\d{4}$/;
       const errorMessage = !phone
            ? requiredFieldMessage
            : !phonePattern.test(phone)
            ? translate("Phone number must be in the format (XXX) XXX-XXXX.")
            : "";
        setPhoneError(errorMessage);
         return !errorMessage;
            
    };

    const validateSubmitEnabled = () => {
        return !(emailError || firstNameError || lastNameError || companyNameError || messageError || cityError || phoneError || provinceError);
    };

    const emailChangeHandler = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : validateEmail(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        setEmail(email);
    };

    const phoneChangeHandler = (phone: string) => {
        let numericPhone = phone.replace(/\D/g, "");

        if (numericPhone.length <= 3) {
            numericPhone = `(${numericPhone}`;
        } else if (numericPhone.length <= 6) {
            numericPhone = `(${numericPhone.slice(0, 3)}) ${numericPhone.slice(3)}`;
        } else {
            numericPhone = `(${numericPhone.slice(0, 3)}) ${numericPhone.slice(3, 6)}-${numericPhone.slice(6, 10)}`;
        }

        if (numericPhone.length <= 14) {
            setPhone(numericPhone);
        }

        validatePhone(numericPhone);
    };

    const cityChangeHandler = (city: string) => {
        validateCity(city);
        setCity(city);
    };

    const provinceChangeHandler = (province: string) => {
        validateProvince(province);
        setProvince(province);
    };

    const messageChangeHandler = (message: string) => {
        validateMessage(message);
        setMessage(message);
    };

    const validateMessage = (message: string) => {
        const errorMessage = !message ? requiredFieldMessage : "";
        setMessageError(errorMessage);
        return !errorMessage;
    };

    const validateProvince = (province: string) => {
        const errorMessage = !province ? requiredFieldMessage : "";
        setProvinceError(errorMessage);
        return !errorMessage;
    };

    const validateCity = (city: string) => {
        const errorMessage = !city ? requiredFieldMessage : "";
        setCityError(errorMessage);
        return !errorMessage;
    };

    const firstNameChangeHandler = (name: string) => {
        validateFirstName(name);
        setFirstName(name);
    };

    const lastNameChangeHandler = (lastName: string) => {
        validateLastName(lastName);
        setLastName(lastName);
    };

    const firmNameChangeHandler = (companyName: string) => {
        validateFirmName(companyName);
        setCompanyName(companyName);
    };

    const onSuccessHandler = ({ quoteCartId }: BrickModel) => {
        removeQuoteCartFromLocalStorage();
        history.push(`request_quote/cart/success?id=${quoteCartId}`);
    };

    const getAttributeKeyValue = (product: ProductModel) => {
        const attributes = getAttributesWithLabelValue(product) as AttributeKeyTypeWithLabel;
        const newAttributes: { [key: string]: string } = {};
        Object.keys(attributes).forEach(item => {
            if (attributes[item].value) {
                newAttributes[item] = attributes[item].value;
            }
        });
        return newAttributes;
    };

    const storeQuote = async () => {
        const emailAddress = email;
        const phoneNumber = phone;
        const quoteLines = cart.products.map(product => ({
            productId: product.id,
            name: product.productTitle,
            attributes: getAttributeKeyValue(product),
            imageUrl: product.mediumImagePath,
        }));

        const sanitizedEmailRecipients = emailRecipients.replace(/\s/g, "").replace(/,\n/g, ",");

        try {
            const response = await brickService({
                type: "BrickQuote",
                firstName,
                lastName,
                companyName,
                emailAddress,
                phoneNumber,
                city,
                province,
                message,
                emailTo: sanitizedEmailRecipients,
                quoteLines,
            });

            if (response?.successful === true) {
                onSuccessHandler({
                    quoteCartId: response.result as string,
                });
            }
        } catch (error) {
            console.error("Error submitting quote:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!isSubmitted) {
            setIsSubmitted(true);
        }

        if (!validateSubmitEnabled()) {
            return;
        }
        
        const isReCaptchaValid = await validateReCaptcha({ location: "BrickSelector", recaptchaRef });
		
        if (!isReCaptchaValid) {
            return;
        }

        setIsSubmitting(true);
        storeQuote();
    };

    const isSubmitEnabled = validateSubmitEnabled();

    return (
        <StyledForm {...styles.form} onSubmit={submitHandler} noValidate>
            <StyledWrapper>
                <Typography {...styles.formHeading} variant="h4" as="h4">
                    {translate("Personal Details")}
                </Typography>
            </StyledWrapper>
            <GridContainer {...styles.mainGridContainer}>
                <GridItem {...styles.userGridItem}>
                    <GridContainer {...styles.userGridContainer}>
                        <GridItem {...styles.userNameGridItem}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("First Name")}
                                value={firstName}
                                data-test-selector="first_Name"
                                onChange={e => firstNameChangeHandler(e.currentTarget.value)}
                                error={isSubmitted && firstNameError}
                                maxLength={256}
                                required
                            />
                        </GridItem>
                        <GridItem {...styles.userNameGridItem}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("Last Name")}
                                value={lastName}
                                data-test-selector="last_Name"
                                onChange={e => lastNameChangeHandler(e.currentTarget.value)}
                                error={isSubmitted && lastNameError}
                                maxLength={256}
                                required
                            />
                        </GridItem>
                        <GridItem {...styles.companyNameGridItem}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("Firm/ Company")}
                                value={companyName}
                                data-test-selector="firm_name"
                                onChange={e => firmNameChangeHandler(e.currentTarget.value)}
                                error={isSubmitted && companyNameError}
                                maxLength={256}
                                required
                            />
                        </GridItem>
                        <GridItem {...styles.emailGridItem}>
                            <TextField
                                {...styles.emailTextField}
                                type="email"
                                label={translate("Email Address")}
                                onChange={e => emailChangeHandler(e.currentTarget.value)}
                                value={email}
                                data-test-selector="email"
                                maxLength={256}
                                required
                                error={isSubmitted && emailError}
                            />
                        </GridItem>
                        <GridItem {...styles.userNameGridItem}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("Phone")}
                                value={phone}
                                data-test-selector="phone"
                                onChange={e => phoneChangeHandler(e.currentTarget.value)}
                                error={isSubmitted && phoneError}
                                maxLength={14}
                                required
                                inputMode="numeric"
                                onKeyDown={(e) => {
                                    if (!/[0-9]/.test(e.key) && !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </GridItem>

                        {errorMessage && (
                            <GridItem data-test-selector="createAccount_ErrorMessage" {...styles.submitErrorGridItem}>
                                <Typography {...styles.submitErrorTitle}>{errorMessage}</Typography>
                            </GridItem>
                        )}
                    </GridContainer>
                </GridItem>
            </GridContainer>
            <StyledWrapper>
                <Typography {...styles.formHeading} variant="h4" as="h4">
                    {translate("Project Details")}
                </Typography>
            </StyledWrapper>
            <GridContainer {...styles.mainGridContainer}>
                <GridItem {...styles.userGridItem}>
                    <GridContainer {...styles.userGridContainer}>
                        <GridItem {...styles.userNameGridItem}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("City")}
                                value={city}
                                data-test-selector="city"
                                onChange={e => cityChangeHandler(e.currentTarget.value)}
                                error={isSubmitted && cityError}
                                maxLength={256}
                                required
                            />
                        </GridItem>
                        <GridItem {...styles.userNameGridItem}>
                            <Select
                                {...styles.selectProvince}
                                label={translate("Province")}
                                value={province}
                                data-test-selector="province"
                                onChange={e => provinceChangeHandler(e.currentTarget.value)}
                                error={isSubmitted && provinceError}
                                required
                            >
                                <option value="">{translate("Select a Province")}</option>
                                {provinces.map(item => (
                                    <option value={item.value} key={item.value}>
                                        {item.title}
                                    </option>
                                ))}
                            </Select>
                        </GridItem>
                        <GridItem {...styles.textAreaGrid}>
                            <TextArea
                                {...styles.shareMessageTextArea}
                                label={translate("Message")}
                                value={message}
                                data-test-selector="message"
                                onChange={e => messageChangeHandler(e.currentTarget.value)}
                                error={isSubmitted && messageError}
                                maxLength={500}
                                required
                            />
                        </GridItem>

                        {errorMessage && (
                            <GridItem data-test-selector="createAccount_ErrorMessage" {...styles.submitErrorGridItem}>
                                <Typography {...styles.submitErrorTitle}>{errorMessage}</Typography>
                            </GridItem>
                        )}
                    </GridContainer>
                </GridItem>
                <GridItem {...styles.reCaptchaGridItem}>
                    <ReCaptcha recaptchaRef={recaptchaRef} location="BrickSelector" />
                </GridItem>
            </GridContainer>
            <GridItem {...styles.submitGridItem}>
                <Button
                    {...styles.submitButton}
                    type="submit"
                    disabled={isSubmitting || (isSubmitted && !isSubmitEnabled)}
                    data-test-selector="submit_button"
                >
                    {translate("Submit")}
                </Button>
            </GridItem>
        </StyledForm>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(withHistory(QuoteCartForm)),
    definition: {
        displayName: "Quote Cart Form",
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.emailRecipients,
                displayName: "Email recipients",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "testaccount@insitesoft.com",
                isRequired: true,
                regularExpression: emailsRegexp,
            },
        ],
    },
};

export default widgetModule;
